import React from 'react';

type Point = { label: string; value: number };

function monthLabelFromPeriodStart(periodStart: string) {
  const d = new Date(periodStart);
  return d.toLocaleDateString('en-US', { month: 'short' });
}

export function UsageChart(props: { history: Array<{ period_start: string; comment_summaries: number }>; limit: number }) {
  const { history, limit } = props;
  const points: Point[] = (history ?? []).map((h) => ({
    label: monthLabelFromPeriodStart(h.period_start),
    value: h.comment_summaries ?? 0,
  }));

  const width = 560;
  const height = 160;
  const padding = 28;

  const maxY = Math.max(limit || 0, ...points.map((p) => p.value), 1);
  const xStep = points.length > 1 ? (width - padding * 2) / (points.length - 1) : 0;

  const xy = points.map((p, i) => {
    const x = padding + i * xStep;
    const y = height - padding - (p.value / maxY) * (height - padding * 2);
    return { x, y, ...p };
  });

  const path = xy
    .map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x.toFixed(2)} ${p.y.toFixed(2)}`)
    .join(' ');

  const limitY = height - padding - ((limit || 0) / maxY) * (height - padding * 2);

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4">
      <div className="flex items-center justify-between mb-2">
        <h4 className="font-semibold text-black">Usage (last {Math.min(points.length, 6)} periods)</h4>
        <div className="text-xs text-gray-600">Limit line: {limit || 0}</div>
      </div>

      {points.length === 0 ? (
        <div className="text-sm text-gray-600">No usage history available yet.</div>
      ) : (
        <svg viewBox={`0 0 ${width} ${height}`} className="w-full">
          {/* grid */}
          <line x1={padding} y1={height - padding} x2={width - padding} y2={height - padding} stroke="#e5e7eb" />
          <line x1={padding} y1={padding} x2={padding} y2={height - padding} stroke="#e5e7eb" />

          {/* limit */}
          {limit > 0 && (
            <line x1={padding} y1={limitY} x2={width - padding} y2={limitY} stroke="#f59e0b" strokeDasharray="4 4" />
          )}

          {/* series */}
          <path d={path} fill="none" stroke="#16a34a" strokeWidth="2" />
          {xy.map((p) => (
            <circle key={`${p.label}-${p.x}`} cx={p.x} cy={p.y} r="3" fill="#16a34a" />
          ))}

          {/* x labels */}
          {xy.map((p) => (
            <text key={`${p.label}-t`} x={p.x} y={height - 10} textAnchor="middle" fontSize="10" fill="#6b7280">
              {p.label}
            </text>
          ))}
        </svg>
      )}
    </div>
  );
}


